<template>
  <div
    :id="id"
    :class="`card ${theme}`"
  >
    <nuxt-link :to="`article/${article.slug}`">
      <div class="card-image">
        <img
          :src="articleImage"
          alt="article"
        />
      </div>
      <div class="card-content">
        <div class="card-info">
          <p class="date">
            {{ `${article.published_at} · ${article.read_time}` }}
          </p>
          <h2 class="title">{{ article.title }}</h2>
          <p class="description">{{ description }}</p>
        </div>
        <ReadMore />
      </div>
    </nuxt-link>
  </div>
</template>

<script>
import ReadMore from '~/components/Common/ReadMore/ReadMore.vue';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';
export default {
  components: { ReadMore },
  props: {
    article: {
      type: Object,
      default: () => {},
    },
    id: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'light',
      validator: (value) => ['light', 'dark'].includes(value),
    },
  },
  computed: {
    description() {
      return this.article.description?.replace(/\r?\n|\r/g, ' ').trim();
    },
    articleImage() {
      return this.article.image
        ? cloudinaryImage({ imagePath: this.article.image, width: 700 })
        : '/images/common/article-placeholder.svg';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ArticleCard.scss';
</style>
